import * as E from 'fp-ts/Either';

const hasProtocol = (s: string) =>
  s.startsWith('http://') || s.startsWith('https://');

export const parseUrl = (value: string) => {
  const valueWithProtocol = hasProtocol(value) ? value : `http://${value}`;

  return E.tryCatch(
    () => new URL(valueWithProtocol),
    () => 'cannot parse URL',
  );
};
